export default {
  SET_EVALUATIONUSERINFO: 'SET_EVALUATIONUSERINFO', // old
  SET_USERINFO: 'SET_USERINFO',
  SET_USEREVALUATIONINFO: 'SET_USEREVALUATIONINFO', // new
};
